import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {update} from "../../../app/setters/update.js";

export const useEdytujOperatora = () => {

    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (data) => update(`/uzytkownicy`, {...data, czy_manager: data.czy_manager ?? "Nie"}),
        onError: () => {
            toast.error('Błąd podczas operacji')
        },

        onSettled: async () => {
            await queryClient.invalidateQueries({
                queryKey: ['uzytkownicy_oper'],
            });
        },

        onSuccess: ({message}) => {
            toast.success(message)
        }
    })
}